import { useFeatureFlag } from '@src/hooks';
import { usePricingRules } from '@src/providers';
import { useCallbackRef } from '@talos/kyoko';
import { useMemo } from 'react';
import { getCustomerAggregationsAllowDeleteEntity, getInUseAggregationNamesSet } from './utils';

export function useCustomerAggregationsDelete() {
  const { requireCustomerPricingRulesCounterpartyFilter } = useFeatureFlag();
  const { pricingRules, isPricingRulesLoading } = usePricingRules();
  const inUseAggregationNames = useMemo(
    () => getInUseAggregationNamesSet(pricingRules, isPricingRulesLoading),
    [pricingRules, isPricingRulesLoading]
  );
  // allowDeleteEntity must stay stable so EntityAdmin does not rebuild row actions when pricing rules update.
  // The getter still reads the latest in-use set when delete is evaluated.
  const getInUseAggregationNames = useCallbackRef(() => inUseAggregationNames);

  // Deleting an aggregation is not allowed if ui.RequireCustomerPricingRulesCounterpartyFilter is true.
  const allowDeleteEntity = useMemo(() => {
    if (requireCustomerPricingRulesCounterpartyFilter) {
      return false;
    }
    return getCustomerAggregationsAllowDeleteEntity(getInUseAggregationNames);
  }, [getInUseAggregationNames, requireCustomerPricingRulesCounterpartyFilter]);

  const blotterTableContext = useMemo(() => {
    const availability = inUseAggregationNames == null ? 'loading' : [...inUseAggregationNames].toSorted().join('\0');
    return { customerAggregationDeleteAvailability: availability };
  }, [inUseAggregationNames]);

  return { allowDeleteEntity, blotterTableContext };
}
